module.exports = __webpack_public_path__ + "static/img/rs_js_16.b315ec9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rs/rs_js_16.png
// module id = Jbdu
// module chunks = 1